import { Box, Divider, Grid, Typography, useTheme } from "@mui/material";
import ItemIcon from "src/assets/icon/item";

// show customer name, email, address, companyid
export const CustomItemListItem = ({
  option,
  index,
  getOptionProps,
  onChange,
  handleCloseMenu,
}: any) => {
  const theme = useTheme();
  return (
    <Grid
      container
      component="li"
      {...getOptionProps({ option, index })}
      key={"option_" + option?.id + "_" + index}
      sx={{
        alignItems: "flex-start",
        padding: "8px 8px",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      }}
      onClick={() => {
        onChange(null, option);
        handleCloseMenu();
      }}
    >
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "top", gap: 1 }}>
          <ItemIcon height={22} width={22} />
          <Box>
            <Typography
              sx={{
                fontSize: "12px",
                color: "text.primary",
              }}
            >
              {option.code}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {option.name && (
                <>
                  <Typography sx={{ fontSize: "11px", color: "#657482" }}>
                    {option.name}
                  </Typography>
                  <Divider
                    style={{
                      width: "1px",
                      height: "12px",
                    }}
                    light
                    orientation="vertical"
                  />
                </>
              )}
              <Typography
                sx={{
                  fontSize: "11px",
                  color: "text.secondary", //"#657482"]
                }}
              >
                {option.price}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
